import { AbstractDataSourceBase } from "abweb/dto/generated/ds/AbstractDataSourceBase";
export class AbstractDataSource extends AbstractDataSourceBase {
  constructor() {
    super();
  }
}
//# sourceMappingURL=AbstractDataSource.js.map
